module.exports = __webpack_public_path__ + "media/images/fine-wines-edee3a842ee780a915e1492e22f02e85.webp";